module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/list_recommend-02a5f780adcc1c9ef81e82263696fc7c.png";